import {
  DeleteOutlined,
  DiffOutlined,
  EditOutlined,
  FieldTimeOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Empty, Form, message, Pagination, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useEffect, useMemo, useState } from 'react'
import { v4 as uuidv4 } from 'uuid' // Import uuid
import {
  convertPriceToNumber,
  formatCurrencyLabel,
  getLabelByValue,
  hasPermission,
  removeNullUndefined
} from '../../config-func'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import { departmentSearch } from '../../services/cmsservice'
import {
  addressSearch,
  addressSearchAll,
  getListUserDepartment,
  getUserManagePost,
  postAdd,
  postDelete,
  postDetail,
  postSearch,
  postUpdate,
  projectSearch,
  upLoadImage
} from '../../services/postservice'
import { getAllSelectionsList } from '../../services/selection-list-service'
import {
  buildSubProductTypeFromCategory,
  getSubProductType,
  mapSelectionByCategory
} from '../../utils/helpers'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import ExportButton from '../common/ExportButton'
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormAddExcel from './FormAddExcel'
import FormPost from './FormPost'
import HistoryModal from './HistoryModal'
import Manage from './Manage'
import Note from './Note'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  FURNITURE_TYPE,
  LabelType,
  POLICY_DOCUMENT,
  PROCCESS_TRANFER,
  ProductType,
  SECURITY_TYPE,
  status,
  statusList
} from './configs'
import Loading from '../Loading'
// const { TextArea } = Input

// const { Option } = Select
export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
// const { TabPane } = Tabs

const PostManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [pageSize, setPageSize] = useState(10) // Kích thước trang mặc định
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [listDepartment, setListDepartment] = useState([])
  const [data, setData] = useState([])
  // Form thêm mới
  const [loading, setLoading] = useState(false)
  const [postType, setPostType] = useState('')
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })
  // const [listUser, setListUser] = useState([])
  const [listProject, setListProject] = useState([])
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])

  // Upload ảnh
  const [fileList, setFileList] = useState([])
  const [fileListVideo, setFileListVideo] = useState([])
  const [fileList360, setFileList360] = useState([])
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewImage, setPreviewImage] = useState()
  const [previewTitle, setPreviewTitle] = useState()

  const [isModalImportOpen, setIsModalImportOpen] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [isModalManagerRequest, setIsModalManagerRequest] = useState(false)
  const [isOpenCall, setIsOpenCall] = useState(false)
  // Lấy tên quản lý tin theo id bản ghi
  const [isText, setIsText] = useState(false)

  const [recordId, setRecordId] = useState()
  const [isModalNote, setIsModalNote] = useState(false)
  const [listAllSelections, setListAllSelections] = useState([])
  const [demandOps, setDemandOps] = useState([])
  const [typeOfRealEstateOps, setTypeOfRealEstateOps] = useState([])
  const [apartmentLocationOptions, setApartmentLocationOptions] = useState([])
  const [directionOptions, setDirectionOptions] = useState([])
  const [furnitureOptions, setFurnitureOptions] = useState([])
  const [legalOptions, setLegalOptions] = useState([])
  const [procedureOptions, setProcedureOptions] = useState([])
  const [currentStatusOpstions, setCurrentStatusOpstions] = useState([])
  const [postStatusOptions, setPostStatusOptions] = useState([])
  const [postSecurityOptions, setPostSecurityOptions] = useState([])

  const user_role = localStorage.getItem('user_role')
  // const [listPostUser, setListPostUser] = useState([])
  // const getListUserPost = async (postId) => {
  //   try {
  //     const res = await listUserPost(postId)
  //     if (res?.data) {
  //
  //       // setListPostUser(res?.data?.list)
  //     }
  //   } catch (err) {
  //     openNotification('error', 'Đã có lỗi xảy ra')
  //   } finally {
  //   }
  // }
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60
      // render: (_, __, index) => (page - 1) * pageSize + index + 1
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 150
    },
    {
      title: 'SĐT khách hàng',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 170,
      exportValue: (record) => record?.customer_phone_number,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.customer_phone_number}
          postId={record?.id}
        />
      )
    },
    // {
    //   title: 'Email',
    //   dataIndex: 'customer_email',
    //   key: 'customer_email'
    // },
    {
      title: 'Người đăng tin',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <span>{record?.user_info?.name}</span>
      }
    },

    {
      title: 'SĐT người đăng',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 170,
      exportValue: (record) => record?.user_info?.phone,
      render: (_, record) => {
        return (
          <PhoneVisibilityCell
            value={record?.user_info?.phone}
            postId={record?.id}
          />
        )
      }
    },
    {
      title: 'Tên Sàn',
      dataIndex: 'department_id',
      key: 'department_id',
      width: 120,
      render: (_, record, index) => {
        const name = listDepartment.find(
          (n) => n.id === record.department_id
        )?.name
        return <span>{name}</span>
      }
    },
    {
      title: 'Quản lý tin',
      dataIndex: 'manager_post_id',
      key: 'manager_post_id',
      width: 150,
      render: (text, record) => {
        const userIds = record.post_manager_info.map(
          (post) => post.manager_post_id
        )

        const names = listUserDepartment
          .filter((user) => userIds.includes(user.id))
          .map((user) => user.name)
          .join(', ')
        // getListUserPost(record.id)
        return <>{names}</>
      }
      // render: (text) => <span>{'Ko biết'}</span>
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label',
      width: 90,
      render: (_, record) => (
        <span>
          {LabelType.find((n) => n.value === record.label)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      width: 150,
      render: (_, record) => (
        <span>
          {typeOfRealEstateOps.find(
            (n) => Number(n.value) === Number(record.post_type)
          )?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình BĐS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>
          {getLabelByValue(record.type_real_estate, listAllSelections)}
        </span>
      )
    },
    {
      title: 'Dự án',
      dataIndex: 'project_id',
      key: 'project_id',
      width: 200,
      render: (_, record) => (
        <span>
          {listProject.find((n) => n.id === record.project_id)?.project_name ||
            ''}
        </span>
      )
    },
    {
      title: 'Số địa chỉ',
      dataIndex: 'alley',
      key: 'alley',
      width: 150
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'apartment_code',
      key: 'apartment_code',
      width: 120
    },
    {
      title: 'Toà',
      dataIndex: 'building',
      key: 'building',
      width: 100
    },
    {
      title: 'Tầng',
      dataIndex: 'floor',
      key: 'floor',
      width: 80,
      render: (_, record) => (
        <span>
          {Number(record.post_type) === 1
            ? record.floor
            : record.number_of_floor}
        </span>
      )
    },
    {
      title: 'Số căn',
      dataIndex: 'number_of_rooms',
      key: 'number_of_rooms',
      width: 80
    },
    {
      title: 'Số phòng ngủ',
      dataIndex: 'number_of_bedrooms',
      key: 'number_of_bedrooms',
      width: 130
    },
    {
      title: 'Số WC',
      dataIndex: 'number_of_wc',
      key: 'number_of_wc',
      width: 80
    },
    {
      title: 'Diện tích (m2)',
      dataIndex: 'acreage',
      key: 'acreage',
      width: 130
    },
    {
      title: 'Mặt tiền (m)',
      dataIndex: 'area_outside',
      key: 'area_outside',
      width: 130
    },
    {
      title: 'Vị trí',
      dataIndex: 'apartment_location',
      key: 'apartment_location',
      width: 120,
      render: (_, record) => (
        <span>
          {APARTMENT_TYPE.find((n) => n.value === record.apartment_location)
            ?.label || record.apartment_location}
        </span>
      )
    },
    {
      title: 'Hướng',
      dataIndex: 'direction',
      key: 'direction',
      width: 120,
      render: (_, record) => (
        <span>
          {BALCONY_DIRECTION.find((n) => n.value === record.direction)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Nội thất',
      dataIndex: 'furniture',
      key: 'furniture',
      width: 120,
      render: (_, record) => (
        <span>
          {FURNITURE_TYPE.find((n) => n.value === record.furniture)?.label ||
            ''}
        </span>
      )
    },
    {
      title: 'Giấy tờ pháp lý',
      dataIndex: 'legal',
      key: 'legal',
      width: 150,
      render: (_, record) => (
        <span>
          {POLICY_DOCUMENT.find((n) => n.value === record.legal)?.label || ''}
        </span>
      )
    },
    {
      title: 'Phí giao dịch',
      dataIndex: 'procedure',
      key: 'procedure',
      width: 150,
      render: (_, record) => (
        <span>
          {PROCCESS_TRANFER.find((n) => n.value === record.procedure)?.label ||
            ''}
        </span>
      )
    },

    {
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      width: 80,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    {
      title: 'Phí môi giới',
      dataIndex: 'cost',
      key: 'cost',
      width: 120,
      render: (_, record) => <span>{formatCurrencyLabel(record.cost)}</span>
    },
    {
      title: 'Hiện trạng',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (_, record) => (
        <span>
          {status.find((n) => n.value === record.status)?.label || ''}
        </span>
      )
    },
    {
      title: 'Trạng thái tin',
      dataIndex: 'processing_status',
      key: 'processing_status',
      width: 150,
      render: (_, record) => (
        <span>
          {statusList.find((n) => n.value === record.processing_status)
            ?.label || ''}
        </span>
      )
    },

    {
      title: 'Bảo mật thông tin',
      dataIndex: 'security',
      key: 'security',
      width: 170,
      render: (_, record) => (
        <span>
          {SECURITY_TYPE.find((n) => n.value === record.security)?.label || ''}
        </span>
      )
    },
    // {
    //   title: 'Note',
    //   dataIndex: 'note',
    //   key: 'note'
    // },
    {
      title: 'Mô tả',
      dataIndex: 'description',
      key: 'description',
      width: 200,
      render: (text) => (
        <div
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: 'break-word',
            lineHeight: '1.5'
          }}
        >
          {text || ''}
        </div>
      )
    },

    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.city_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.district_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'town_code',
      key: 'town_code',
      width: 150,
      render: (_, record) => (
        <span>{record?.town_info?.name || 'Đang xác minh'}</span>
      )
    },
    {
      title: 'Đường phố',
      dataIndex: 'street',
      key: 'street',
      width: 150
    },
    {
      title: 'Email',
      width: 100,
      dataIndex: 'customer_email',
      key: 'customer_email'
    },

    // {
    //   title: 'Hướng ban công',
    //   dataIndex: 'HUONGBANCONG',
    //   key: 'HUONG_BANCONG',
    //   render: (text) => <span>{'Ko biết'}</span>
    // },

    // {
    //   title: 'Giá',
    //   dataIndex: 'price',
    //   key: 'price',
    //   render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    // },
    // {
    //   title: 'Giá bán',
    //   dataIndex: 'price',
    //   key: 'price',
    //   render: (price) => <span>{formatCurrency(price)}</span>,
    // },

    // {
    //   title: 'Ảnh',
    //   dataIndex: 'post_files',
    //   key: 'post_files',
    //   render: (post_files) => (
    //     <div style={{ display: 'flex', gap: '5px', height: '50px' }}>
    //       {post_files?.map((file) => {
    //         if(file.type === 2) return null
    //         return <img
    //           key={file.id}
    //           src={file.link}
    //           alt="Post"
    //           width={50}
    //           height={50}
    //           style={{ objectFit: 'cover', cursor: 'pointer' }}
    //           onClick={() => {
    //             setPreviewImage(file.link)
    //             setPreviewVisible(true)
    //             setPreviewTitle(false)
    //           }}
    //         />
    //       })}
    //     </div>
    //   )
    // },

    {
      title: 'Thời gian đăng',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.created_at
            ? dayjs.unix(record?.created_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Thời gian cập nhật',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 170,
      render: (_, record) => (
        <span>
          {record?.updated_at
            ? dayjs.unix(record?.updated_at).format('DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    // {
    //   title: 'Hình ảnh',
    //   dataIndex: 'post_files',
    //   key: 'post_files',
    //   render: (post_files) => {
    //     return (
    //       <div style={{ display: 'flex', gap: '5px', height: '50px' }}>
    //         {post_files?.map((file) => {
    //         if(file.type === 'IMAGE') {
    //           return <img
    //             key={file.id}
    //             src={file.link}
    //             alt="Post"
    //             width={50}
    //             height={50}
    //             style={{ objectFit: 'cover', cursor: 'pointer' }}
    //             onClick={() => {
    //               setPreviewImage(file.link)
    //               setPreviewVisible(true)
    //               setPreviewTitle(false)
    //             }}
    //           />
    //         }
    //         })}
    //       </div>
    //     )
    //   }
    // },
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      exportSkip: true,
      render: (_, record) => {
        return (
          <Space size="small">
            {/* <Tooltip title="Chỉnh sửa">
              <EditOutlined
                onClick={() => {
                  setMode(ACTION_MODE.UPDATE)
                  getDetailPost(record.id)
                }}
                style={{ fontSize: '16px', color: '#08c', cursor: 'pointer' }}
              />
            </Tooltip> */}
            {hasPermission('P37.4', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)
                    getDetailPost(record.id)
                    setRecordId(record.id)
                  }}
                />
                {/* ><EditOutlined /> Edit</Button> */}
              </Tooltip>
            )}

            {hasPermission('P37.5', permissions) && (
              <Tooltip title="Xem lịch sử">
                <Button
                  onClick={() => {
                    setRecordId(record.id)
                    setIsOpenCall(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Xem lịch sử
                </Button>
              </Tooltip>
            )}

            {hasPermission('P37.6', permissions) && (
              <Tooltip title="Xem lịch sử Note">
                <Button
                  onClick={() => {
                    // setMode(ACTION_MODE.UPDATE)
                    // getDetailRequest(record.id)
                    setRecordId(record.id)
                    setIsModalNote(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Note
                </Button>
              </Tooltip>
            )}
            {record.status !== 'inactive' &&
              hasPermission('P37.9', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xoá',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xoá tin
                            <b> {record.title}</b> không?
                          </div>
                        ),
                        onOk: () => deletePost([record.id])
                      })
                    }
                  />
                </Tooltip>
              )}
            {/* <Button type="primary">Chi tiết</Button>
            <Button danger>Xóa</Button> */}
          </Space>
        )
      }
    }
  ]
  const SUB_PRODUCT_TYPE_DYNAMIC = useMemo(
    () =>
      buildSubProductTypeFromCategory(listAllSelections, [
        'APARTMENT_BDS',
        'BUILDING_BDS',
        'GROUND_BDS',
        'REAL_ESTATE_BDS'
      ]),
    [listAllSelections]
  )

  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e, SUB_PRODUCT_TYPE_DYNAMIC)

    // const formattedArray = type?.map((item) => ({ value: item, label: item }))

    // Reset value and error for project_id
    form.setFields([
      {
        name: 'project_id',
        errors: []
      }
    ])
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
    setPostType(e)
  }

  // Lấy danh sách post
  const getListPost = async (values = {}) => {
    setLoading(true)

    const value = removeNullUndefined(values)
    try {
      const body = {
        ...value,
        type_new: 1,
        sortBy: 'id',
        page: value.page || pagination.current,
        pageSize: pagination.pageSize
      }
      const res = await postSearch(body)

      setData(res.data)
      // setPagination((prev) => ({
      //   ...prev
      // }))
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()
      getListPost({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  const handleSearch = debounce((values) => {}, 300)

  // Thêm sửa post
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      let img_360 = []

      if (isText) {
        img_360 = values.image_360?.map((item) => ({
          type: 'IMAGE360',
          link: item.url
        }))
      } else {
        img_360 = values.img360?.fileList?.map((item) => ({
          type: 'IMAGE360',
          link: item.response?.[0]?.link
        }))
      }

      const fileImg = fileList?.map((item) => ({
        link: item.response?.[0]?.link || item.url, // Lấy link từ response hoặc url
        type: 'IMAGE'
      }))
      const fileVideo = fileListVideo?.map((item) => ({
        link: item.response?.[0]?.link || item.url, // Lấy link từ response hoặc url
        type: 'VIDEO'
      }))
      // const video = normalizeData(fileListVideo)
      const { id, video_urls, image_360, img360, manager_post_id, ...data } =
        values

      const normalizeMoneyField = (value) => {
        if (value === null || value === undefined || value === '') {
          return undefined
        }

        return convertPriceToNumber(value?.toString())
      }

      if (!recordId && mode !== ACTION_MODE.ADD) {
        openNotification(
          'error',
          'Bản ghi này không có id , vui lòng chọn tin khác'
        )
        return
      }
      let body = {}

      body = {
        ...data,

        from: 2,
        content: values.content ? values.content : null,
        files: [...fileImg, ...fileVideo, ...(img_360 || [])],
        number_of_rooms:
          values.number_of_rooms && values.number_of_rooms?.toString(),
        price: normalizeMoneyField(values.price),
        cost: normalizeMoneyField(values.cost)
      }
      const res =
        mode == ACTION_MODE.ADD
          ? await postAdd({ ...body, manager_post_id })
          : // ? await postAdd(body)
            await postUpdate(body, recordId)
      if (res && res.data?.id) {
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Tạo tin thành công'
            : 'Cập nhật tin thành công'
        )
        const value = formSearch.getFieldsValue()
        getListPost({
          ...value,
          page: pagination.current,
          pageSize: pagination.pageSize
        })
        form.resetFields()
        setIsModalOpen(false)
        setFileList([])
        setFileList360([])
        setFileListVideo([])
        setLoading(false)
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
        setLoading(false)
      }
    } catch (err) {
      // Lấy danh sách lỗi từ API
      setLoading(false)

      const errors = get(err, 'response.data.message', [])

      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
    }
  }

  // Chi tiết quyền
  const getDetailPost = async (id) => {
    setLoading(true)
    try {
      const res = await postDetail(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = {
          ...res.data,
          label: String(res.data.label),
          post_type: String(res.data.post_type),
          type_real_estate: String(res.data.type_real_estate),
          apartment_location: String(res.data.apartment_location),
          direction: String(res.data.direction),
          legal: String(res.data.legal),
          procedure: String(res.data.procedure),
          furniture: String(res.data.furniture),
          status: String(res.data.status),
          processing_status: String(res.data.processing_status),
          security: String(res.data.security)
        }

        // form.setFieldsValue({
        //   ...values
        // })

        getListDistricts(values.city_code)
        getListTowns(values.district_code)
        const type = getSubProductType(
          values.post_type,
          SUB_PRODUCT_TYPE_DYNAMIC
        )
        setTypeRealEstate(type)
        setPostType(values.post_type)
        // getUserAll(values.department_id)
        getUserDepartment(values.department_id)
        // Hàm để format dữ liệu
        const formatFiles = (fileList) =>
          fileList.map((item) => ({
            uid: uuidv4(), // ID duy nhất
            url: item.link, // Link ảnh/video từ API
            name: uuidv4(), // Tên file ngẫu nhiên
            status: 'done' // Đánh dấu đã tải lên thành công
            // thumbUrl: item.link // Ảnh thu nhỏ
            // type: item.type // IMAGE hoặc VIDEO
          }))

        const images = formatFiles(
          values?.post_files.filter((file) => file.type === 'IMAGE')
        )

        const videos = formatFiles(
          values?.post_files.filter((file) => file.type === 'VIDEO')
        )
        const others = formatFiles(
          values?.post_files.filter(
            (file) => file.type !== 'IMAGE' && file.type !== 'VIDEO'
          )
        )

        setFileList(images)
        setFileListVideo(videos)
        setFileList360(others)
        form.setFieldsValue({ ...values, image_360: others })
      } else {
        openNotification('error', 'Không tìm thấy dữ liệu')
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }
  //

  // lấy thông tin quản lý tin
  const getUserManage = async (id) => {
    try {
      const res = await getUserManagePost(id) // Assuming roleSearch is an API function

      if (res && res.data) {
      } else {
      }
    } catch (err) {}
  }

  // Danh sách sàn
  const getDepartmentAll = async (values) => {
    let { name = '', type = '', page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { name, type, page, pageSize }
      const res = await departmentSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.name
      }))
      setListDepartment(result)
    } catch (err) {}
  }

  // Danh sách tài khoản theo SÀN
  // const getUserAll = async () => {
  //   let page = 1
  //   let pageSize = 1000
  //   const deId = localStorage.getItem('department_id')
  //   try {
  //     const body = {
  //       page,
  //       pageSize,
  //       department_id: deId
  //     }
  //     const res = await getListStaff(body) // Assuming roleSearch is an API function
  //     if (res && res.list) {
  //       const result = res?.list.map((item) => ({
  //         ...item,
  //         value: item.id,
  //         label: item.name
  //       }))
  //       setListUser(result) // Update the state with the list of roles
  //     } else {
  //       // Handle the case where the response is unexpected or empty
  //
  //       setListUser([]) // Optionally, reset the list to an empty array
  //     }
  //   } catch (err) {
  //     // Handle the error gracefully
  //
  //     // You might want to show a notification or alert to the user here
  //     setListUser([]) // Optionally, reset the list to an empty array
  //   }
  // }

  // Danh sách dự án
  const getProjectAll = async (values) => {
    let { page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { page, pageSize }
      const res = await projectSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.project_name
      }))

      setListProject(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  // Danh sách thành phố
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    // const code = cities.filter((item) => item.id == i)?.[0].code
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách phường xã
  const getListTowns = async (code) => {
    // const type = 'town'
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getSelection = async () => {
    try {
      const res = await getAllSelectionsList()
      setListAllSelections(res || [])
    } catch (err) {}
  }

  useEffect(() => {
    // getUserAll()
    getDepartmentAll()
    getProjectAll()
    getListCities()
    getSelection()
  }, [])
  useEffect(() => {
    setTimeout(() => {
      mapSelectionByCategory(listAllSelections, [
        {
          // nhu cầu
          category: 'DEMAND',
          setState: setDemandOps
        },
        {
          // loại bất động sản
          category: 'TYPE_OF_REAL_STATE',
          setState: setTypeOfRealEstateOps
        },
        {
          // vị trí căn hộ
          category: 'LOCATION',
          setState: setApartmentLocationOptions
        },
        {
          // hướng căn hộ
          category: 'DIRECTION',
          setState: setDirectionOptions
        },
        {
          // phí giao dịch
          category: 'PROCEDURE',
          setState: setProcedureOptions
        },
        {
          // giấy tờ pháp lý
          category: 'LEGAL',
          setState: setLegalOptions
        },
        {
          // nội thất
          category: 'FURNITURE',
          setState: setFurnitureOptions
        },
        {
          // hiện trạng
          category: 'CURRENT_STATUS',
          setState: setCurrentStatusOpstions
        },
        {
          // trạng thái tin
          category: 'POST_STATUS',
          setState: setPostStatusOptions
        },
        {
          // trạng thái tin
          category: 'POST_SECURITY',
          setState: setPostSecurityOptions
        }
      ])
    }, 0)
  }, [listAllSelections])
  // func
  const onChangeProject = async (value) => {
    const dataProject = _.find(listProject, (el) => el.id === value)

    // const codeCity = cities.filter((item) => item.code == dataProject.city)?.[0]
    //   ?.id
    await getListDistricts(dataProject?.city_code)
    await getListTowns(dataProject?.district_code)

    form.setFieldsValue({
      city_code: dataProject?.city_code ? dataProject.city_code : null,
      district_code: dataProject?.district_code
        ? dataProject.district_code
        : null,
      town_code: dataProject?.town_code ? dataProject.town_code : null,
      street: dataProject?.address ? dataProject.address : null,
      project_name: dataProject?.project_name ? dataProject.project_name : null
    })
  }

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  const [listUserDepartment, setListUserDepartment] = useState([])
  // Danh sách tài khoản theo SÀN
  const getUserDepartment = async (id) => {
    let page = 1
    let pageSize = 1000

    try {
      const body = {
        page,
        pageSize,
        department_id: id
      }
      const res = await getListUserDepartment(body) // Assuming roleSearch is an API function
      if (res && res.data.list) {
        const result = res?.data?.list.map((item) => ({
          ...item,
          value: item.id,
          label: item.name
        }))
        setListUserDepartment(result) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty

        setListUserDepartment([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      // Handle the error gracefully
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
      // You might want to show a notification or alert to the user here
      setListUserDepartment([]) // Optionally, reset the list to an empty array
    }
  }

  useEffect(() => {
    const department_id = localStorage.getItem('department_id')
    if (user_role === 'ADMIN') {
      getUserDepartment('')
    } else {
      getUserDepartment(department_id)
    }
  }, [])

  const onChangeDepartment = async (value) => {
    await getUserDepartment(value)

    form.setFieldsValue({
      manager_post_id: null
    })
  }

  // Xử lý khi upload thay đổi

  const handleCancel = () => {
    setPreviewVisible(false)
  }

  const handlePreview = async (file) => {
    if (file.response) {
      setPreviewImage(file.response?.[0]?.link)
      setPreviewVisible(true)
      setPreviewTitle(false)
    } else {
      setPreviewImage(file.url)
      setPreviewVisible(true)
      setPreviewTitle(false)
    }
  }

  const [totalSize, setTotalSize] = useState(0) // Lưu tổng dung lượng video & 360 (MB)

  const handleCustomRequest = async (options, type) => {
    const { file, onSuccess, onError, onProgress } = options
    // Tạo FormData và append file vào formData
    const formData = new FormData()
    type == 'image'
      ? formData.append('file_image', file)
      : type == 'video'
      ? formData.append('file_video', file)
      : formData.append('file_360', file)

    try {
      // Gọi API upload thông qua hàm upLoadImage
      const response = await upLoadImage(formData)

      // Nếu có tiến trình upload, bạn có thể gọi onProgress
      if (onProgress) {
        onProgress({ percent: 100 })
      }
      // Gọi onSuccess của Upload để thông báo upload thành công
      onSuccess(response.data, file)

      // 👉 Nếu là video hoặc 360 thì tính dung lượng
      if (type === 'video' || type === '360') {
        const fileSizeMB = file.size / 1024 / 1024 // Chuyển Byte -> MB
        setTotalSize((prevSize) => prevSize + fileSizeMB)
      }

      // message.success(`${file.name} upload thành công!`)
    } catch (error) {
      const err = error?.response?.data?.message || ''
      openNotification('error', err || 'upload thất bại')
      onError(error)
    }
  }

  const handleChange = (info, type) => {
    let newFileList = [...info.fileList]

    // Chỉ cập nhật fileList nếu không có lỗi
    newFileList = newFileList.filter((file) => {
      if (file.status == 'error') {
        message.error(`Upload thất bại: ${file.name}`)
      }
      return file.status !== 'error'
    })
    type == 'image'
      ? setFileList(newFileList)
      : type == 'video'
      ? setFileListVideo(newFileList)
      : setFileList360(newFileList)
  }

  // Xóa tin
  const deletePost = async (ids) => {
    setLoading(true)
    try {
      // Validate các trường trong form
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const deId = localStorage.getItem('department_id')
      // Lọc ra các key có giá trị true và đưa vào mảng
      const body = {
        ids,
        department_id: deId,
        type: 9,
        from: 2
      }
      const res = await postDelete(body)
      // getListRequest()
      const value = formSearch.getFieldsValue()
      getListPost({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      setLoading(false)

      setSelectedRowKeys([])
      openNotification('success', res.message)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const [citiesAll, setCitiesAll] = useState([])
  const [districtsAll, setDistrictsAll] = useState([])
  const [townsAll, setTownsAll] = useState([])

  // Danh sách thành phố
  const getListCitiesAll = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCitiesAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách quận huyện
  const getListDistrictsAll = async () => {
    try {
      const res = await addressSearchAll('district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setDistrictsAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách phường xã
  const getListTownsAll = async () => {
    try {
      const res = await addressSearchAll('town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setTownsAll(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  useEffect(() => {
    getListCitiesAll()
    getListDistrictsAll()
    getListTownsAll()
  }, [])
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          form={formSearch}
          getListPost={getListPost}
          listDepartment={listDepartment}
          listProject={listProject}
          cities={cities}
          districts={districts}
          towns={towns}
          user={listUserDepartment}
          onChangePostType={onChangePostType}
          listTypeRealEstate={typeRealEstate}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          pagination={pagination}
          setPagination={setPagination}
          demandOps={demandOps}
          typeOfRealEstateOps={typeOfRealEstateOps}
          apartmentLocationOptions={apartmentLocationOptions}
          directionOptions={directionOptions}
          furnitureOptions={furnitureOptions}
          currentStatusOpstions={currentStatusOpstions}
          postStatusOptions={postStatusOptions}
          postSecurityOptions={postSecurityOptions}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý tin BĐS nội bộ</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <ExportButton
              columns={initialColumns}
              data={data?.list}
              fileName="Quan_ly_tin_BDS_noi_bo"
              sheetName="Tin BĐS nội bộ"
              permission="P37.10"
            />

            {hasPermission('P37.2', permissions) && (
              <Button
                type="primary"
                key="primary"
                onClick={() => {
                  setIsModalImportOpen(true)
                }}
              >
                <PlusOutlined /> Import Excel
              </Button>
            )}

            {hasPermission('P37.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}

            {hasPermission('P37.3', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  if (selectedRowKeys.length == 0) {
                    openNotification('error', 'Vui lòng chọn tin')
                  } else {
                    const department_id = localStorage.getItem('department_id')
                    if (user_role == 'ADMIN') {
                      getUserDepartment('')
                    } else {
                      getUserDepartment(department_id)
                    }

                    setIsModalManagerRequest(true)
                  }
                }}
              >
                <DiffOutlined />
                Chọn quản lý
              </Button>
            )}

            {hasPermission('P37.9', permissions) && (
              <Button
                danger
                // disabled={selectedRowKeys.length > 0 ? false : true}
                type="primary"
                onClick={() => {
                  if (selectedRowKeys.length == 0) {
                    openNotification('error', 'Vui lòng chọn tin')
                  } else {
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá{' '}
                          <b>{selectedRowKeys?.length}</b> tin không?
                        </div>
                      ),
                      onOk: () => deletePost(selectedRowKeys)
                    })
                  }
                }}
              >
                <DeleteOutlined />
                Xoá
              </Button>
            )}
          </div>
        </div>
        <TableField
          // loading={loading}
          columns={initialColumns}
          data={data?.list}
          scroll={{
            x: data?.list?.length > 0 ? 'max-content' : '100%',
            y: 'calc(100vh - 400px)'
          }}
          className={`custom-table`}
          // pagination={{
          //   current: pagination.current,
          //   pageSize: pagination.pageSize,
          //   total: data?.total,
          //   pageSizeOptions: PAGE_SIZE_OPTIONS,
          //   showSizeChanger: true,
          //   onChange: handlePageChange,
          //   showTotal: (total, range) =>
          //     `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
          // }}
          pagination={false}
          rowKey="id"
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys), // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '16px',
            padding: '16px 0'
          }}
        >
          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={data?.total}
            pageSizeOptions={PAGE_SIZE_OPTIONS}
            showSizeChanger={true}
            showQuickJumper={true}
            showTotal={(total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
            }
            locale={{
              items_per_page: 'bản ghi / trang',
              jump_to: 'Đến trang',
              page: ''
            }}
            onChange={(page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize || prev.pageSize
              }))
            }}
            onShowSizeChange={(current, size) => {
              setPagination((prev) => ({
                ...prev,
                pageSize: size,
                current: 1
              }))
            }}
          />
        </div>
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa tin đăng'
            : 'Thêm mới tin đăng'
        }
        visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
          setFileList([])
          setFileListVideo([])
          setFileList360([])
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          } finally {
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost
          form={form}
          handleSearch={handleSearch}
          listDepartment={listDepartment}
          listUser={listUserDepartment}
          LabelType={LabelType}
          ProductType={ProductType}
          typeRealEstate={typeRealEstate}
          listProject={listProject}
          cities={cities}
          districts={districts}
          towns={towns}
          postType={postType}
          fileList={fileList}
          handleCustomRequest={handleCustomRequest}
          handleChange={handleChange}
          handlePreview={handlePreview}
          previewVisible={previewVisible}
          previewTitle={previewTitle}
          handleCancel={handleCancel}
          onChangeProject={onChangeProject}
          previewImage={previewImage}
          onChangePostType={onChangePostType}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          fileListVideo={fileListVideo}
          fileList360={fileList360}
          onChangeDepartment={onChangeDepartment}
          totalSize={totalSize}
          mode={mode}
          setFileList360={setFileList360}
          setIsText={setIsText}
          isText={isText}
          getListPost={getListPost}
          recordId={recordId}
          demandOps={demandOps}
          typeOfRealEstateOps={typeOfRealEstateOps}
          apartmentLocationOptions={apartmentLocationOptions}
          directionOptions={directionOptions}
          furnitureOptions={furnitureOptions}
          legalOptions={legalOptions}
          procedureOptions={procedureOptions}
          currentStatusOpstions={currentStatusOpstions}
          postStatusOptions={postStatusOptions}
          postSecurityOptions={postSecurityOptions}
          loading={loading}
          setLoading={setLoading}
        />
      </ModalCustom>
      <FormAddExcel
        isModalOpen={isModalImportOpen}
        setIsModalOpen={setIsModalImportOpen}
        listProject={listProject}
        listDepartment={listDepartment}
        user={listUserDepartment}
        getListPost={getListPost}
        onChangeDepartment={onChangeDepartment}
        setListUserDepartment={setListUserDepartment}
        setLoading={setLoading}
      />

      <ModalCustom
        title="Thêm quản lý tin"
        visible={isModalManagerRequest}
        centered
        width={600}
        onCancel={() => {
          setIsModalManagerRequest(false)
          setListUserDepartment([])
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <Manage
          setOpen={setIsModalManagerRequest}
          requestId={selectedRowKeys}
          data={listUserDepartment}
          getList={getListPost}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </ModalCustom>
      <ModalCustom
        title="Danh sách quản lý note"
        visible={isModalNote}
        centered
        width={600}
        onCancel={() => {
          setIsModalNote(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <Note
          postId={recordId}
          getListPost={getListPost}
          loading={loading}
          setLoading={setLoading}
        />
      </ModalCustom>
      <HistoryModal
        id={recordId}
        isOpen={isOpenCall}
        setIsOpen={setIsOpenCall}
        listDepartment={listDepartment}
        cities={citiesAll}
        districts={districtsAll}
        towns={townsAll}
        loading={loading}
        setLoading={setLoading}
      />
      {/* <Modal
        open={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="preview" style={{ width: '100%' }} src={previewImage} />
      </Modal> */}
      <ModalConfirm />
    </div>
  )
}

export default PostManagement
